import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as DeleteIcon } from "src/images/trash-can.svg";

export default function RemoveCreatorButton({ handleRemove }) {
  return (
    <Button
      size="medium"
      variant="white-to-red"
      onClick={handleRemove}
      data-qa="remove-creator-button"
    >
      <DeleteIcon />
      <IDHFormattedMessage id="front_remove" defaultMessage="Remove" />
    </Button>
  );
}
